import React, { useEffect } from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import TemplateWhatsAppBlipProvider from "./TemplateWhatsAppBlipContext";
import PesquisarTemplateWhatsAppBlip from "./Events/PesquisarTemplateWhatsAppBlip";
import FormularioTemplateWhatsAppBlip from "./Events/FormularioTemplateWhatsAppBlip";
import { LoadMask } from "../../../../Utils/mask";

const Index = () => {
  let match = useRouteMatch();
  useEffect(() => {
    LoadMask();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <TemplateWhatsAppBlipProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarTemplateWhatsAppBlip}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioTemplateWhatsAppBlip}
          />
        </Switch>
      </div>
    </TemplateWhatsAppBlipProvider>
  );
};

export default Index;
